import { Paper } from "@mui/material";

import { TextInput } from "@dzambalaorg/mui-inputs-core";
import { FormGrid } from "@dzambalaorg/ui-kit";

export interface ISocialInputProps {
  name: string;
}

export const SocialInput = (props: ISocialInputProps) => {
  const { name } = props;
  return (
    <Paper sx={{ mt: 2, mb: 2, p: 2 }}>
      <FormGrid columns={[2, 2]}>
        <TextInput name={`${name}.twitterUrl`} />
        <TextInput name={`${name}.instagramUrl`} />
        <TextInput name={`${name}.youtubeUrl`} />
        <TextInput name={`${name}.facebookUrl`} />
      </FormGrid>
    </Paper>
  );
};
